<template>
  <div :class="{ 'container-dark': theme_dark }">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">礼物投诉</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="main">
      <span></span>
      <div class="item">
        <div class="receive">
          <img :src="gift.photo_url" />
          <span>{{gift.nick}}</span>
        </div>
        <div class="send">
          <span>赠送</span>
          <img src="../../assets/img/右箭头.png" />
          <span>{{gift.dtm}}</span>
        </div>

        <div class="gift">
          <img :src="gift.gift_url" />
          <span>{{gift.gift_name}}</span>
        </div>
      </div>
    </div>

    <div class="paper ub">
      <textarea placeholder="详细描述" v-model="txt"></textarea>
    </div>

    <li class="up-block" v-for="(i,index) in ayy_pic" :key="index" >
      <img :src="i" class="paper-img" />
    </li>
    <div class="tip">
      <span>{{tip}}</span>
    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      gift_id: "",
      txt: "",
      ayy_pic: [],
      gift: {},
      state: "",
      tip: "",
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    var id = this.$route.params.id;
    this.gift_id = id;
    this.init();
    this.init2();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    init() {
      var const_data = this.$store.state.const_data;
      var ary_gift = const_data.gift_1.concat(const_data.gift_2);

      var self = this;
      this.get({
        url: "/App/GetGiftOne_Tosu/" + self.gift_id,
        success: function (data) {
          //console.log(JSON.stringify(data));
          data.photo_url = self.$store.state.url + "/photo/" + data.photo;
          var gift_item = tool.getGiftItemBy_name(ary_gift, data.gift_name);
          data.gift_url = gift_item.url;
          self.gift = data;
        },
      });
    },
    init2() {
      var self = this;
      this.get({
        url: "/App/GetGiftOneData/" + this.gift_id,
        success: function (data) {
          //console.log(JSON.stringify(data));
          if (data.id) {
            var brife = data.brife;
            self.txt = brife;
            var pics = data.pics;
            self.ayy_pic = JSON.parse(pics);
            self.state = data.state;
            if (self.state == "待审核") {
              self.tip = "该礼物已被投诉，请等待平台审核~";
            }
            if (self.state == "通过") {
              self.tip = "平台处理结果：" + data.rst_check;
            }
            if (self.state == "失败") {
              self.tip = "平台处理结果：" + data.rst_check;
            }
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0.8rem;
  background-color: white;
  .item {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .receive {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        border-radius: 50%;
        width: 3.3rem;
        margin: 0.4rem 0;
      }
      span {
        font-size: 0.85rem;
        color: #333;
      }
    }
    .send {
      padding: 0 0.3rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 0.7rem;
        color: #333;
      }
      img {
        width: 9rem;
        height: 0.8rem;
      }
    }
    .gift {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 3.5rem;
      }
      span {
        font-size: 0.85rem;
        color: #333;
      }
    }
  }
}

.paper {
  margin-top: 1.5rem;
  padding: 0 0.8rem;
  textarea {
    width: 100%;
    height: 8.5rem;
    outline: none;
    resize: none;
    font-size: 0.9rem;
    padding: 0.35rem 0.55rem;
    line-height: 1.5rem;
    border-radius: 0.25rem;
    color: #666;
    border-color: #7ac7df;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  textarea:focus {
    border-color: #0680f1;
  }
}

.up-block {
  position: relative;
  padding: 0.8rem;
  background-color: white;
  .paper-img {
    border: 1px dashed #6b6b6b;
    width: 100%;
  }
}

.tip {
  padding: 0 0.8rem 2rem 0.8rem;
  background-color: white;
  span {
    font-size: 0.85rem;
    color: #f17806;
  }
}

.container-dark {
  background-color: #2f2e33;
  .main {
      background-color: #2c2b30;
      .gift {
        span {
          color: #fdfdfd;
        }
      }
      .send {
        span {
          color: #888;
        }
      }
      .receive {
        span {
          color: #fdfdfd;
        }
      }
    }
    .paper {
        textarea {
          background-color: #2c2b30;
          border-color: #404040;
          color: #888;
        }
        textarea:focus {
          border-color: #404040;
        }
      }
      .paper textarea:focus {
        border-color: #404040;
      }
    .up-block {
        background-color: #2f2e33;
    }
    .tip {
      background-color: #2f2e33;
    }
}
</style>